import { API_URL } from '../config/api';
import { getPositionDescription } from '../i18n';

export const JOB_DESCRIPTIONS_UPDATED_EVENT = 'helport_job_descriptions_updated';

export const fetchJobDescriptionsMap = async () => {
  try {
    const response = await fetch(`${API_URL}?action=get_job_descriptions`);
    const data = await response.json();
    if (data.status !== 'success' || !Array.isArray(data.data)) {
      return {};
    }

    return data.data.reduce((map, row) => {
      if (row?.position_title) {
        map[row.position_title] = row.description || '';
      }
      return map;
    }, {});
  } catch (error) {
    console.error('Error fetching job descriptions:', error);
    return {};
  }
};

export const resolvePositionDescription = (lang, position, savedDescriptions = {}) => {
  const saved = String(savedDescriptions[position] || '').trim();
  if (saved) return saved;
  return getPositionDescription(lang, position);
};

export const notifyJobDescriptionsUpdated = () => {
  window.dispatchEvent(new Event(JOB_DESCRIPTIONS_UPDATED_EVENT));
};
